<app-card [showHeader]="false">
    <app-footer-entry-page-tools [service]="serviceInstance" />
    <!-- <div class="p-b-15">
        <app-base-criteria>
            <ng-content select="[criteria]"></ng-content>
        </app-base-criteria>
    </div> -->
    <div class="p-t-15">
        <ng-content select="[form]"></ng-content>
    </div>
</app-card>